<template>
  <div class="container">
    <div class="columns is-marginless is-centered has-text-centered is-mobile">
      <!-- number of blocks -->
      <div class="column is-paddingless is-narrow">
        <div class="status-bg has-bg-1">
          <p class="status-title">{{ $utils.addComma(chainStatus.blockHeight) }}</p>
          <p class="card-line">
            <img :src="require('../../assets/card_line@2x.png')" alt="">
          </p>
          <p class="status-body">{{ $t("network.num_of_blocks") }}</p>
        </div>
      </div>
      <!-- lasttime of block mined -->
      <div class="column is-paddingless is-narrow">
        <div class="status-bg has-bg-2">
          <p class="status-title">{{ lastBlockTime }}</p>
          <p class="card-line">
            <img :src="require('../../assets/card_line@2x.png')" alt="">
          </p>
          <p class="status-body">{{ $t("network.latest_block") }}</p>
        </div>
      </div>
      <!-- number of consensus peers -->
      <div class="column is-paddingless is-narrow">
        <div class="status-bg has-bg-3">
          <p class="status-title">1</p>
          <p class="card-line">
            <img :src="require('../../assets/card_line@2x.png')" alt="">
          </p>
          <p class="status-body">{{ $t("network.consensus_peers") }}</p>
        </div>
      </div>
      <!-- transaction in seconds -->
      <div class="column is-paddingless is-narrow">
        <div class="status-bg has-bg-4">
          <p class="status-title">{{ transactionPerSecond }}</p>
          <p class="card-line">
            <img :src="require('../../assets/card_line@2x.png')" alt="">
          </p>
          <p class="status-body">{{ $t("network.tx") }}</p>
        </div>
      </div>
    </div>
    <!-- tx sampler -->
    <line-chart class="line-chart" :data="txDataForChart" :options="chartOptions"></line-chart>
  </div>
</template>

<script>
  import LineChart from './LineChart'
  import { mapState } from 'vuex'

  export default {
    name: 'network-status',
    components: { LineChart },
    data () {
      return {
        chartOptions: {
          animation: false,
          responsive: true,
          maintainAspectRatio: false,
          legend: {
            display: false
          },
          scaleOverride: true,
          scaleStepWidth: 1,
          scaleStartValue: 0
        }
      }
    },
    computed: {
      ...mapState(['chainStatus']),
      lastBlockTime () {
        if (this.chainStatus.lastBlockTime) {
          const last = this.chainStatus.lastBlockTime
          const d = new Date()
          const now = d.getTime()
          if (now / 1000 - last < 30) {
            return '' + parseInt(now / 1000 - last) + 's'
          } else {
            return this.$utils.fromNow(last)
          }
        } else {
          return 'n/a'
        }
      },
      transactionPerSecond () {
        return Number.parseFloat('' + this.chainStatus.transactionsPerHour / 3600).toFixed(3)
      },
      txSamples () {
        let samples = this.chainStatus.txSamples.slice(0)
        samples = samples.filter(s => s !== null)
        samples.sort((a, b) => (a.timestamp === b.timestamp) ? 0 : (a.timestamp > b.timestamp) ? 1 : -1)
        return samples
      },
      txDataForChart () {
        return {
          labels: this.txSamples.map((d, i) => {
            if (i % 2 === 0) {
              return ''
            } else {
              return this.$utils.formatTimestamp(d.timestamp, 'HH:mm')
            }
          }),
          datasets: [
            {
              label: 'tx/s',
              fill: true,
              lineTension: 0.3,
              backgroundColor: 'rgba(75,192,192,0.4)',
              borderColor: 'rgba(75,192,192,1)',
              borderCapStyle: 'butt',
              borderDash: [],
              borderDashOffset: 0.0,
              borderJoinStyle: 'miter',
              pointBorderColor: 'rgba(75,192,192,1)',
              pointBackgroundColor: '#000',
              pointBorderWidth: 5,
              pointHoverRadius: 5,
              pointHoverBackgroundColor: 'rgba(75,192,192,1)',
              pointHoverBorderColor: 'rgba(220,220,220,1)',
              pointHoverBorderWidth: 2,
              pointRadius: 1,
              pointHitRadius: 10,
              data: this.txSamples.map(d => d.rate),
              spanGaps: true
            }
          ]
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  .line-chart {
    background-color: #fff;
    margin-top: 4rem;
    margin-bottom: 4rem;
  }

  @media screen and (max-width: 899px) {
    .status-title {
      color: #666;
      font-size: 1rem;
      font-weight: normal;
      padding-top: 1.5rem;
    }

    .status-body {
      color: #666;
      font-size: .7rem;
      font-weight: normal;
      padding-left: .8rem;
      padding-right: .8rem;
      margin-top: .5rem;
    }

    .status-bg {
      width: 5.7rem;
      height: 7.6rem;
    }

    .card-line {
      margin-top: -.5rem;
      padding-left: .8rem;
      padding-right: .8rem;
      img {
        height: 100%;
      }
    }
  }

  @media screen and (min-width: 900px) {
    .status-title {
      color: #666;
      font-size: 2rem;
      font-weight: normal;
      padding-top: 3rem;
    }

    .status-body {
      color: #666;
      font-size: 1.5rem;
      font-weight: normal;
      padding-top: .5rem;
      padding-left: 1.5rem;
      padding-right: 1.5rem;
    }

    .status-bg {
      width: 12rem;
      height: 16rem;
    }

    .card-line {
      padding-left: 1.5rem;
      padding-right: 1.5rem;
    }
  }

  .has-bg-1 {
    background-image: url("../../assets/node_bg1.png");
    background-position: center;
    background-size: 100% 100%;
  }

  .has-bg-2 {
    background-image: url("../../assets/node_bg2.png");
    background-position: center;
    background-size: 100% 100%;
  }

  .has-bg-3 {
    background-image: url("../../assets/node_bg3.png");
    background-position: center;
    background-size: 100% 100%;
  }

  .has-bg-4 {
    background-image: url("../../assets/node_bg4.png");
    background-position: center;
    background-size: 100% 100%;
  }
</style>



// WEBPACK FOOTER //
// src/components/layout/NetworkStatus.vue